import './Main.css'

import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useWizard, WizardData } from './context'
import { useAppContext } from '@/context/app'
import { useForm, UseFormReturn } from 'react-hook-form'
import { addServerErrors } from '@/components/forms/common/FormBase'
import { FormData, QuickCreateMachineForm } from './types'
import { CategoryItemSelectPopup } from '@/popups/machineCategory/selectMachineCategory'
import { MachineTypeSelectPopup } from '@/popups/machineType/selectMachineType'
import { MachineType } from '@/services/model/machine'

export const CreateMachineWizardStep2 = () => {
  const { services, session, translates } = useAppContext()
  const { wizardData, updateWizardData, nextStep, prevStep } = useWizard()

  const [isEdited, setEdited] = useState<boolean>(false)

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <div>
    {!isEdited && wizardData.machine?.machineType !== undefined ? <div className='selected-machine-type' onClick={() => setEdited(true)}>
      <h3>{translates.for('popup.create_machine_wizard.select_machine_type_title')}</h3>
      <p>
        {translates.for('popup.create_machine_wizard.select_machine_type_description')
          .replace('{manufacturer}', wizardData.machine.machineType.manufacturer)
          .replace('{model}', wizardData.machine.machineType.model)
          .replace('{category}', translates.for('machine.types.' + wizardData.machine.machineType.category))}
      </p>
    </div> : <MachineTypeSelectPopup onClose={() => { }} onSelect={(machineType: MachineType) => {
      updateWizardData({
        ...wizardData,
        machine: {
          ...wizardData.machine,
          machineType: machineType
        }
      })
      nextStep()
    }} />}

    <div className='right-btns'>
      <button className='btn btn-next' onClick={() => {
        prevStep()
      }}>{translates.for('popup.create_machine_wizard.prev')}</button>
      {wizardData.machine?.machineType?.id ? <button className='btn btn-next' onClick={() => {
        nextStep()
      }}>{translates.for('popup.create_machine_wizard.next')}</button> : null}
    </div>
  </div>
}

